import { useSelfServeContextStore } from "./SelfServeContext";

export const useSelectedBrandOrderNumber = () => {
  const [{ selectedBrandOrder }] = useSelfServeContextStore([
    "selectedBrandOrder",
  ]);
  return selectedBrandOrder?.brand_order?.token ?? "";
};
